import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  variableKeyPlaceholder: {
    id: 'frontbucket.pipelines.settings.repository.variables.name',
    description: 'Placeholder for variable key',
    defaultMessage: 'Name',
  },
  variableValuePlaceholder: {
    id: 'frontbucket.pipelines.settings.repository.variables.value',
    description: 'Placeholder for variable value',
    defaultMessage: 'Value',
  },
  vaultVariableValueWarning: {
    id: 'frontbucket.pipelines.settings.repository.variables.vaultWarning',
    description:
      'Warning message to be shown when user tries to add a vault variable',
    defaultMessage:
      'You are adding a variable stored in the vault, which will be loaded for every build on every branch. If the vault secret is part of a compliant group, builds on non-compliant branches may fail.',
  },
  secured: {
    id: 'frontbucket.pipelines.settings.repository.variables.secured',
    description: 'Label for secured checkbox',
    defaultMessage: 'Secured',
  },
  securedTooltip: {
    id: 'frontbucket.pipelines.settings.repository.variables.securedTooltip',
    description: 'Tooltip text for secured checkbox',
    defaultMessage: 'Secured variables are encrypted and masked in the logs',
  },
  add: {
    id: 'frontbucket.pipelines.settings.repository.variables.add',
    description: 'Label for Add button',
    defaultMessage: 'Add',
  },
});
